import React, { useCallback, useState } from "react";
import { Card } from "@/components/ui/card";
import { SectionHeading } from "@/components/landing/Reveal";
import { ContactInfo } from "@/components/landing/ContactInfo";
import { ContactForm } from "@/components/landing/ContactForm";
import { ContactSuccess } from "@/components/landing/ContactSuccess";

export const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  // Bumping the key guarantees a brand-new form instance (and therefore empty
  // inputs) whenever the visitor chooses to send another enquiry.
  const [formKey, setFormKey] = useState(0);

  const handleSuccess = useCallback(() => setSubmitted(true), []);

  const handleReset = useCallback(() => {
    setFormKey((key) => key + 1);
    setSubmitted(false);
  }, []);

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="scroll-mt-32 lg:scroll-mt-40 bg-white lg:flex lg:min-h-screen lg:items-start pb-10 pt-6 sm:pb-14 sm:pt-8 lg:py-6"
    >
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Contact"
          title="Talk to the head office"
          description="This corporate site is for partners, suppliers, corporate contacts, press and general enquiries."
          wide
        />

        <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-5">
            <ContactInfo />
          </div>

          <div className="lg:col-span-7">
            <Card className="rounded-[16px] border-slate-200 bg-white p-4 shadow-[var(--shadow-md)] sm:p-5">
              {submitted ? (
                <ContactSuccess onReset={handleReset} />
              ) : (
                <ContactForm key={formKey} onSuccess={handleSuccess} />
              )}
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
